import React, { Component } from "react";
import { App } from "../../App";
import { AppScreen } from "../../AppScreen";
import landingMatchingPairs from "../../assets/images/matching-pairs/pairs-landing.svg";
import characterAdventure from "../../assets/images/matching-pairs/adventure.svg";
import characterBump from "../../assets/images/matching-pairs/bump.svg";
import characterChatter from "../../assets/images/matching-pairs/chatter.svg";
import characterCool from "../../assets/images/matching-pairs/cool.svg";
import characterExplorer from "../../assets/images/matching-pairs/explorer.svg";
import characterFunny from "../../assets/images/matching-pairs/funny.svg";
import characterGreedy from "../../assets/images/matching-pairs/greedy.svg";
import characterHappy from "../../assets/images/matching-pairs/happy.svg";
import characterHug from "../../assets/images/matching-pairs/hug.svg";
import characterNosey from "../../assets/images/matching-pairs/nosey.svg";
import characterPrincess from "../../assets/images/matching-pairs/princess.svg";
import characterSplendid from "../../assets/images/matching-pairs/splendid.svg";
import characterStrong from "../../assets/images/matching-pairs/strong.svg";
import characterSunshine from "../../assets/images/matching-pairs/sunshine.svg";
import characterTall from "../../assets/images/matching-pairs/tall.svg";
import characterTickle from "../../assets/images/matching-pairs/tickle.svg";
import characterScatter from "../../assets/images/matching-pairs/scatter.svg";
import characterGiggle from "../../assets/images/matching-pairs/giggle.svg";
import wellDoneText from "../../assets/images/matching-pairs/well-done.png";
import { CloseButton } from "../components/CloseButton";
import { ConfettiAnimation } from "../components/animations/ConfettiAnimation";
import { BirdAnimation } from "../components/animations/BirdAnimation";
import { Util } from "../../Util";

export interface MatchingPairsScreenProps
{
}

interface MatchingPairsScreenState 
{
    screen: Screen;
    levelText: string;
    cards: Array<React.ReactNode>;
    showAnimation: boolean;
    gameComplete: boolean;
}

enum Screen 
{
    Landing,
    Game,
    Complete
}

interface Card 
{
    id: number;
    character: string;
    src: string;
}

interface GameLevel 
{
    level: number;
    completionCount: number;
    cards: Array<Card>;
    levelTitle: string;
}

export class MatchingPairsScreen extends Component<MatchingPairsScreenProps, MatchingPairsScreenState>
{
    private selectedCard: Card = null;
    private selectedCharacterCount: number = 0;

    private matchedTimeout: number = -1;
    private mismatchedTimeout: number = -1;

    private matchedCardIds: Array<string> = [];
    private selectedCardIds: Array<number> = [];

    private levels: Array<GameLevel> = [
        {
            level: 1,
            completionCount: 2,
            levelTitle: "4 Cards",
            cards: [
                {
                    id: 1,
                    character: "bump",
                    src: characterBump,
                },
                {
                    id: 2,
                    character: "bump",
                    src: characterBump,
                },
                {
                    id: 3,
                    character: "chatter",
                    src: characterChatter,
                },
                {
                    id: 4,
                    character: "chatter",
                    src: characterChatter,
                },
            ]
        },
        {
            level: 2,
            completionCount: 4,
            levelTitle: "8 Cards",
            cards: [
                {
                    id: 1,
                    character: "cool",
                    src: characterCool,
                },
                {
                    id: 2,
                    character: "cool",
                    src: characterCool,
                },
                {
                    id: 3,
                    character: "funny",
                    src: characterFunny,
                },
                {
                    id: 4,
                    character: "funny",
                    src: characterFunny,
                },
                {
                    id: 5,
                    character: "hug",
                    src: characterHug,
                },
                {
                    id: 6,
                    character: "hug",
                    src: characterHug,
                },
                {
                    id: 7,
                    character: "sunshine",
                    src: characterSunshine,
                },
                {
                    id: 8,
                    character: "sunshine",
                    src: characterSunshine,
                },
            ]
        },
        {
            level: 3,
            completionCount: 6,
            levelTitle: "12 Cards",
            cards: [
                {
                    id: 1,
                    character: "princess",
                    src: characterPrincess
                },
                {
                    id: 2,
                    character: "princess",
                    src: characterPrincess,
                },
                {
                    id: 3,
                    character: "strong",
                    src: characterStrong,
                },
                {
                    id: 4,
                    character: "strong",
                    src: characterStrong,
                },
                {
                    id: 5,
                    character: "tall",
                    src: characterTall,
                },
                {
                    id: 6,
                    character: "tall",
                    src: characterTall,
                },
                {
                    id: 7,
                    character: "happy",
                    src: characterHappy,
                },
                {
                    id: 8,
                    character: "happy",
                    src: characterHappy,
                },
                {
                    id: 9,
                    character: "tickle",
                    src: characterTickle,
                },
                {
                    id: 10,
                    character: "tickle",
                    src: characterTickle,
                },
                {
                    id: 11,
                    character: "giggle",
                    src: characterGiggle
                },
                {
                    id: 12,
                    character: "giggle",
                    src: characterGiggle
                }
            ]
        },
        {
            level: 4,
            completionCount: 8,
            levelTitle: "16 Cards",
            cards: [
                {
                    id: 1,
                    character: "explorer",
                    src: characterExplorer,
                },
                {
                    id: 2,
                    character: "explorer",
                    src: characterExplorer,
                },
                {
                    id: 3,
                    character: "greedy",
                    src: characterGreedy,
                },
                {
                    id: 4,
                    character: "greedy",
                    src: characterGreedy,
                },
                {
                    id: 5,
                    character: "nosey",
                    src: characterNosey,
                },
                {
                    id: 6,
                    character: "nosey",
                    src: characterNosey,
                },
                {
                    id: 7,
                    character: "scatterbrain",
                    src: characterScatter,
                },
                {
                    id: 8,
                    character: "scatterbrain",
                    src: characterScatter,
                },
                {
                    id: 9,
                    character: "splendid",
                    src: characterSplendid,
                },
                {
                    id: 10,
                    character: "splendid",
                    src: characterSplendid,
                },
                {
                    id: 11,
                    character: "adventure",
                    src: characterAdventure,
                },
                {
                    id: 12,
                    character: "adventure",
                    src: characterAdventure,
                },
                {
                    id: 13,
                    character: "bump",
                    src: characterBump,
                },
                {
                    id: 14,
                    character: "bump",
                    src: characterBump,
                },
                {
                    id: 15,
                    character: "hug",
                    src: characterHug,
                },
                {
                    id: 16,
                    character: "hug",
                    src: characterHug,
                },
            ]
        }
    ];

    private currentLevel: GameLevel = null;
    constructor(props: MatchingPairsScreenProps)
    {
        super(props);

        this.state = {
            screen: Screen.Landing,
            cards: [],
            levelText: "4 Cards",
            showAnimation: false,
            gameComplete: false,
        };
    }

    public componentDidMount(): void
    {
    }

    private onCloseClicked(): void
    {
        App.I.changeScreen(AppScreen.Landing);
    }

    private onPlayGameClicked(): void
    {
        // Seed cards randomly
        let newLevels = this.levels;
        newLevels.map(level => level.cards = Util.shuffleArray(level.cards));

        this.levels = newLevels;

        this.buildCards();

        this.setState({
            screen: Screen.Game
        });
    }

    private buildCards(): void
    {
        let cards = [];

        let currentLevel = 1;
        if (this.currentLevel === null)
        {
            this.currentLevel = this.levels.filter(d => d.level === currentLevel)[0];
        }

        for (let i = 0; i < this.currentLevel?.cards.length; i++)
        {
            let card: Card = this.currentLevel?.cards[i];
            let active: boolean = this.selectedCardIds.indexOf(card.id) > -1;

            let hasMatched: boolean = this.matchedCardIds.indexOf(card.character) > -1;

            cards.push(
                <div className={"card" + (active === true ? " active" : "")} onClick={this.onCardSelected.bind(this, card)} key={card.id}
                    style={{ opacity: hasMatched === true ? 0 : 1 }}>
                    <div className="content">
                        <div className="front">
                        </div>
                        <div className="back">
                            <img src={card.src} alt={card.character} />
                        </div>
                    </div>
                </div>
            );
        }

        this.setState({
            cards: cards,
            levelText: this.currentLevel?.levelTitle
        });
    }

    private canClick: boolean = true;
    private onCardSelected(card: Card): void
    {
        if (this.canClick === false)
        {
            return;
        }

        if (this.selectedCard?.id === card.id)
        {
            return;
        }

        clearTimeout(this.matchedTimeout);
        clearTimeout(this.mismatchedTimeout);

        if (this.selectedCharacterCount === 2)
        {
            this.selectedCard = null;
            this.selectedCharacterCount = 0;
            this.selectedCardIds = [];
        }

        if (this.selectedCard?.character === card.character && this.selectedCard.id !== card.id)
        {
            this.selectedCardIds.push(card.id);
            this.selectedCard = card;
            this.selectedCharacterCount++;

            this.buildCards();
            this.canClick = false;
            this.matchedTimeout = setTimeout(() => this.onMatchFound(card), 500) as any;
        }
        else 
        {
            this.selectedCardIds.push(card.id);
            this.selectedCard = card;
            this.selectedCharacterCount++;
            this.buildCards();

            if (this.selectedCharacterCount === 2)
            {
                this.canClick = false;

                this.mismatchedTimeout = setTimeout(() => this.onNoMatchFound(), 500) as any;
            }
        }
    }

    private onMatchFound(card: Card): void
    {
        this.matchedCardIds.push(card.character);
        this.buildCards();
        this.canClick = true;

        if (this.currentLevel.completionCount === this.matchedCardIds.length)
        {
            this.nextLevel();
        }
    }

    private onNoMatchFound(): void
    {
        this.selectedCardIds = [];
        this.buildCards();
        this.canClick = true;
    }

    private nextLevel(): void
    {
        this.currentLevel = this.levels.filter(l => l.level === this.currentLevel.level + 1)[0];

        if (this.currentLevel)
        {
            this.setState({
                showAnimation: true,
            });
        }
        else
        {
            this.setState({
                showAnimation: true,
                gameComplete: true
            });
        }
    }

    private onAnimationComplete(): void
    {
        this.matchedCardIds = [];
        this.selectedCardIds = [];
        this.selectedCharacterCount = 0;

        if (this.state.gameComplete)
        {
            this.onGameComplete();
        }
        else
        {
            this.setState({
                cards: [],
                showAnimation: false,
            },
                () => this.buildCards()
            );
        }
    }

    private onGameComplete(): void
    {
        document.body.classList.add("complete");
        this.setState({
            screen: Screen.Complete
        });
    }

    private onPlayAgainClicked(): void
    {
        this.currentLevel = null;

        document.body.classList.remove("complete");

        this.setState({
            levelText: "4 Cards",
            cards: [],
            showAnimation: false,
            gameComplete: false
        }, () =>
            this.onPlayGameClicked()
        );
    }

    public componentWillUnmount(): void
    {
        document.body.classList.remove("complete");
    }

    public render(): JSX.Element
    {
        return (
            <>
                <CloseButton onClicked={this.onCloseClicked.bind(this)} />

                <div className="matching-pairs-screen">

                    {
                        (() => 
                        {
                            switch (this.state.screen)
                            {
                                case Screen.Landing:
                                    return (
                                        <div className="container">
                                            <div className="landing-container">
                                                <h1 className="lead-title text-uppercase text-center">
                                                    Matching Pairs
                                                </h1>

                                                <p className="sub-title-light">
                                                    Can you find the cards that are the same?
                                                </p>

                                                <div className="d-flex mb-auto btn-container">
                                                    <button className="btn btn-primary" onClick={this.onPlayGameClicked.bind(this)} title="Play Game">
                                                        Play Game
                                                    </button>

                                                    <div className="d-flex featured-image">
                                                        <img src={landingMatchingPairs} alt={"Matching pair of characters on two cards"} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    );

                                case Screen.Game:
                                    return (
                                        <div className="container">
                                            <h1 className="level-title">
                                                {this.state.levelText}
                                            </h1>

                                            {this.state.showAnimation ?
                                                <div style={{ position: "absolute", top: 0, bottom: 0, left: 0, right: 0, zIndex: 1 }}>
                                                    <ConfettiAnimation onComplete={this.onAnimationComplete.bind(this)} />
                                                </div>
                                                :
                                                <div className="cards">
                                                    <div className={`cards-container level-${this.currentLevel?.level}`}>
                                                        {this.state.cards}
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    );

                                case Screen.Complete:
                                    return (
                                        <div className="game-complete">
                                            <div className="bird-animation">
                                                {/* <BirdAnimation /> */}
                                            </div>

                                            <div className="container">
                                                <div className="search-find-container mt-5">
                                                    <div className="heading-container">
                                                        <img src={wellDoneText} alt="Well done! You completed the quiz!" />

                                                        <div className="mt-1 mb-5 ms-auto me-auto text-center">
                                                            <button className="btn btn-primary" onClick={this.onPlayAgainClicked.bind(this)}>Play again</button>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="d-flex ms-auto me-auto more">
                                                    <button className="btn btn-link" onClick={() => App.I.changeScreen(AppScreen.GamesActivities)}>
                                                        More games
                                                        <i className="bi bi-chevron-right ps-1"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    );
                            }
                        })()
                    }

                </div>
            </>
        );
    }
}